export enum RedirectURLKeys {
  MenuGroup = "MenuA",
  VenueGroup = "VenueA",
  Menu = "MenuV",
  Venue = "VenueV",
  GoBack = "GoBack",
  PaymentGroup = "PaymentA",
  Payment = "PaymentV",
  Group = "VenuesA",
}

export function getRedirectPlaceURL() {
  const path = window.location.pathname.split("/");
  if (window.location.pathname.includes("payment")) {
    return RedirectURLKeys.Payment;
  }
  if (path[1] === "g") {
    if (window.location.pathname.includes("menu")) {
      return RedirectURLKeys.MenuGroup;
    }
    if (path.length === 3) {
      return RedirectURLKeys.Group;
    }
    return RedirectURLKeys.VenueGroup;
  } else if (path[1] === "v") {
    if (window.location.pathname.includes("menu")) {
      return RedirectURLKeys.Menu;
    }
    return RedirectURLKeys.Venue;
  }
  return null;
}
